export default "__VITE_ASSET__D3mw2l7$__"